/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_identity_pool_id": "ap-southeast-2:20ef3956-d25e-41f7-9530-8c88504ca6ab",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_RCku9GpBX",
    "aws_user_pools_web_client_id": "6hhporcgfqbcef9itfcsbbsl5s",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://hhl3i2x7vnfi7n2wbhpytgj2re.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;
